import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const Header = () => {
  const { openCart, cartCount } = useCart();

  return (
    <header style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      height: '70px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 20px',
      backgroundColor: '#0D0D0D',
      fontFamily: "'TASA Orbiter Display', sans-serif",
    }}>
      <Link
        to="/collection"
        style={{
          color: '#F1F1F1',
          textDecoration: 'none',
          fontSize: '14px',
          fontWeight: '400',
          opacity: 0.9,
        }}
      >
        Collection
      </Link>

      <Link to="/" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
        <img
          src="/logo.png"
          alt="Logo"
          style={{ height: '50px', width: 'auto' }}
        />
      </Link>

      <button
        onClick={openCart}
        style={{
          background: 'none',
          border: 'none',
          color: '#F1F1F1',
          fontSize: '14px',
          fontWeight: '400',
          opacity: 0.9,
          cursor: 'pointer',
          fontFamily: "'TASA Orbiter Display', sans-serif",
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        Cart
        {cartCount > 0 && (
          <span style={{
            backgroundColor: '#F1F1F1',
            color: '#0D0D0D',
            fontSize: '11px',
            padding: '2px 6px',
            borderRadius: '10px',
            minWidth: '18px',
            textAlign: 'center',
          }}>
            {cartCount}
          </span>
        )}
      </button>
    </header>
  );
};

export default Header;